/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendMilestoneToJiraInput = {
    id?: string | null | undefined;
    customFields?: Array<JiraCustomFieldInputType | null> | null | undefined;
    jiraProjectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type JiraCustomFieldInputType = {
    key?: string | null | undefined;
    value?: string | null | undefined;
};
export type sendMilestoneToJiraMutationVariables = {
    input: SendMilestoneToJiraInput;
};
export type sendMilestoneToJiraMutationResponse = {
    readonly sendMilestoneToJira: {
        readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly jiraId: string | null;
        } | null;
    } | null;
};
export type sendMilestoneToJiraMutation = {
    readonly response: sendMilestoneToJiraMutationResponse;
    readonly variables: sendMilestoneToJiraMutationVariables;
};



/*
mutation sendMilestoneToJiraMutation(
  $input: SendMilestoneToJiraInput!
) {
  sendMilestoneToJira(input: $input) {
    phase {
      id
      name
      jiraId
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendMilestoneToJiraInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMilestoneToJiraPayload",
    "kind": "LinkedField",
    "name": "sendMilestoneToJira",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jiraId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendMilestoneToJiraMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendMilestoneToJiraMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sendMilestoneToJiraMutation",
    "operationKind": "mutation",
    "text": "mutation sendMilestoneToJiraMutation(\n  $input: SendMilestoneToJiraInput!\n) {\n  sendMilestoneToJira(input: $input) {\n    phase {\n      id\n      name\n      jiraId\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'adede70e0d190e6558bcd85fce3a4991';
export default node;
